import Query from "core/api/QueryComponent";
import { IItem, ProductQuery } from "./ProgramQueries";
import React from "react";
import { BlockView } from "common/views/block/BlockView.view";
import Label from "core/components/label/Label";
import { CardView } from "common/views/card/Card.view";
import { RowsView } from "common/views/rows/Rows.view";
import PagingView from "common/views/paging/Paging.view";
import StringUtil from "core/util/StringUtil";

export const RenderTrackItemsLazy = ({
    track,
    courseFramentPops,
    pageNumber,
}: IItem) => {
    return (
        <Query.Root
            entity={ProductQuery}
            args={{
                id: track.id,
                language: courseFramentPops.course.language,
                pageSize: courseFramentPops.pageSize || 20,
                pageNumber: pageNumber,
            }}
        >
            {({ data }) => {
                if (
                    !data ||
                    !data.programTrackProducts ||
                    data.programTrackProducts.length <= 0
                ) {
                    return null;
                }

                return (
                    <TrackItem courseFramentPops={courseFramentPops} track={track} products={data.programTrackProducts} pageNumber={pageNumber} showPaging={true} />
                );
            }}
        </Query.Root>
    );
};

export const RenderTrackItemsEager = ({
    track,
    courseFramentPops,
    pageNumber,
    products,
}: IItem) => {
    if (!products || products.length <= 0) {
        return null;
    }

    return (
        <TrackItem courseFramentPops={courseFramentPops} track={track} products={products} pageNumber={pageNumber} showPaging={false} />
    );
};

const TrackItem = ({ courseFramentPops, track, products, pageNumber, showPaging }: IItem) => {
    let { renderChildCourse } = courseFramentPops;

    const disableTrackView =
        track.status &&
        track.status.length &&
        track.status.find((status) => status.disableTrackView);
    let completedIndex: number = 0;

    if (
        typeof renderChildCourse === "function" &&
        track.products &&
        track.products.length
    ) {
        if (track.sequential) {
            // find highest sort index that the user hasn't completed
            completedIndex = products
                .slice()
                .sort((a, b) => a.sortIndex - b.sortIndex)
                .reduce((index, tp) => {
                    if (
                        tp.course &&
                        !(
                            tp.course.completion === "Completed" ||
                            tp.course.completion === "Passed"
                        )
                    ) {
                        return index;
                    }
                    return tp.sortIndex;
                }, 0);
        }
    }

    return (
        <React.Fragment key={track.id + "-products"}>
            {!!disableTrackView && <Label k="track.disabled.msg" v="" />}
            <BlockView
                viewKey="program.track.products"
                key={track.id + "-products"}
            >
                <RowsView viewKey="program.track.products.rows">
                    {products.map((product) => {
                        if (product != null && product.course !== null) {
                            const isLaunchable =
                                !disableTrackView &&
                                courseFramentPops.course
                                    .activeSubscriptionExists &&
                                (!track.sequential ||
                                    product.sortIndex <= completedIndex + 1);

                            return (
                                <CardView
                                    viewKey="program.track.product"
                                    key={product.id}
                                >
                                    {product.course &&
                                        renderChildCourse(
                                            product.course,
                                            isLaunchable,
                                            product.required,
                                            isLaunchable
                                        )}
                                </CardView>
                            );
                        }
                    })}
                </RowsView>
            </BlockView>
            {showPaging ? (
            <BlockView viewKey="paging.block">
                <TrackItemPaging
                    courseFramentPops={courseFramentPops}
                    track={track}
                    pageNumber={pageNumber}
                />
            </BlockView>
            ) : null
            }
        </React.Fragment>
    );
};

const TrackItemPaging = ({
    courseFramentPops,
    track,
    pageNumber,
}: IItem) => {
    return (
        <PagingView
            viewKey="paging"
            setPageNumber={(pageNumber) =>
                courseFramentPops.pageActions.setTrackPagination(
                    track.id,
                    pageNumber.toString()
                )
            }
            total={(track.products && track.products.length) || 0}
            pageNumber={StringUtil.toInteger(pageNumber + "") || 0}
            pageSize={courseFramentPops.pageSize || 20}
        />
    );
};



// WEBPACK FOOTER //
// ./src/panels/catalog/fragments/overview/TrackItem.tsx